import type { IProduct } from './product';

export interface IService extends IProduct {
  name: EServices;
  item_id: EServiceItemIds;
}

export enum EServices {
  PremiumOnboarding = 'Premium Onboarding',
  StandardOnboarding = 'Standard Onboarding',
  CampaignManagement = 'Campaign Management Services',
  Pro = 'Pro',
  EmailSwitchServiceKit = 'Email Switch Service Kit',
  ManagedServicesGoogleAdGrantManagement = 'Managed Services - Google Ad Grant Management',
  CampaignManagementServicesGoogleAdGrant = 'Campaign Management Services - Google Ad Grant',
  DataIntegrationServices = 'Data Integration Services',
  CreativeMigrationPack = 'Creative Migration Pack',
  Training = 'Training Services',
  CoPilotLegacy = 'CoPilot - Legacy',
}

export enum EServiceItemIds {
  CampaignManagement = 'I_305',
  DataIntegration = 'I_306',
  PremiumOnboarding = 'I_037',
  StandardOnboarding = 'I_049',
  CreativeMigrationPack = 'I_303',
  CoPilotLegacy = 'I_039',
  ManagedServicesGoogleAdGrantManagement = 'I_308',
  CampaignManagementServicesGoogleAdGrant = 'I_315',
  EmailSwitchServiceKit = 'I_307',
  Training = 'I_043',
  Pro109 = 'I_109',
  Pro112 = 'I_112',
  Pro117 = 'I_117',
  Pro118 = 'I_118',
}
